import { render, staticRenderFns } from "./StockComment.vue?vue&type=template&id=65a67382&scoped=true"
import script from "./StockComment.vue?vue&type=script&lang=js"
export * from "./StockComment.vue?vue&type=script&lang=js"
import style0 from "./StockComment.vue?vue&type=style&index=0&id=65a67382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a67382",
  null
  
)

export default component.exports